export type Address = {
  houseNo: string | undefined;
  streetRoad: string | undefined;
  areaLocality: string | undefined;
  landmark: string | undefined;
  city: string | undefined;
  state: string | undefined;
  pincode: number | undefined;
};

export function getInitialAddressData(): Address {
  return {
    houseNo: undefined,
    streetRoad: undefined,
    areaLocality: undefined,
    landmark: undefined,
    city: undefined,
    state: undefined,
    pincode: undefined,
  };

}

// Helper function to check if a value is valid (non-empty, non-null, and non-undefined)
function isValidTextField(value: string | number | undefined | null): boolean {
  return value !== undefined && value !== null && value.toString().trim() !== '';
}

function isValidNumberField(value: number | undefined | null): boolean {
  return value !== undefined && value !== null && value > 0;
}

// Validate the Address object to ensure all fields are valid
export function validateAddress(address: Address): string | null {
  //Do not validate areaLocality, landmark
  const addressFields: (keyof Address)[] = [
    'houseNo',
    'streetRoad',
    'city',
    'state',
    'pincode'
  ];

  // Iterate over each address field and validate it
  for (const field of addressFields) {
    if (field !== 'pincode') {
      if (!isValidTextField(address[field])) {
        return `${field} is required and cannot be empty, null, or undefined.`;
      }
    }
    else {
      if (!isValidNumberField(address[field])) {
        return `${field} is required and cannot be empty, null, or undefined.`;
      }
    }
  }

  return null; // Return null if all fields are valid
}
